import { IScreenDesignDto } from "./screen-design.dto";

export interface IProjectGenerateRequestDTO {
  projectId: string;
  selectedConfId: string;
  currentSdData: IScreenDesignDto;
  hasLocalSsl: boolean;
  CodeGenerationType: ECodeGenerationType;
  selectedPublishTypes: string;
  /**
   * Internal Kuika-developer opt-in. When true, the generated app also emits the
   * DbMigrationController and MigrationDbScript*.sql files during a Publish
   * (CodeGenerationType.Publish). Normal cloud publishes omit these. Only set by
   * internal (kuikaDevelopers) users from the publish UI; ignored for non-Publish types.
   */
  IncludeMigrationArtifactsOnPublish?: boolean;
}

export interface IWorkflowEngineDownloadConfig {
  workflowEngineBaseUrlSettingsId?: string | null;
  workflowDbConnectionStringSettingsId?: string | null;
  workflowSmtpSettingsId?: string | null;
  workflowAwsSettingsId?: string | null;
  mainDbConnectionStringSettingsId?: string | null;
  cacheSettingsId?: string | null;
}

export enum ECodeGenerationType {
  Publish = 0,
  DownloadSourceCode = 1,
  DownloadExecutables = 2
}
